import { plainToInstance, Type } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { RegisterItemColumn } from '@core/entities/register/RegisterItemColumn'
import {
  IRegisterTemplateDiagram,
  RegisterTemplateDiagramType,
} from '@core/entities/register/RegisterTemplateDiagram'
import { RegisterTemplateDiagramLabel } from '../RegisterTemplateDiagramLabel'

export class RegisterTemplateDiagram extends Entity<IRegisterTemplateDiagram> {
  id: number
  enabled: boolean
  type: RegisterTemplateDiagramType

  @Type(() => RegisterItemColumn)
  identifierProperty: RegisterItemColumn

  @Type(() => RegisterItemColumn)
  colourProperty: RegisterItemColumn

  @Type(() => RegisterTemplateDiagramLabel)
  labels?: RegisterTemplateDiagramLabel[]

  public static new(payload: unknown): RegisterTemplateDiagram {
    const entity = plainToInstance(RegisterTemplateDiagram, payload)

    return entity
  }
}
